import { Api } from "./Api.class";
const endpoint = "tag_entities";
const tagEntitiesAPI = new Api(endpoint);
export default tagEntitiesAPI;
